import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const FleetPolicyPage = lazy(() => import('../pages/FleetPolicyPage'));
const TriggerEventsPage = lazy(() => import('../pages/TriggerEventsPage'));
const TriggersPage = lazy(() => import('../pages/TriggersPage'));
const TriggerPage = lazy(() => import('../pages/TriggerPage'));
const TriggersLandingPage = lazy(() => import('../pages/TriggersLandingPage'));
const CreateAlertFormPage = lazy(() => import('../pages/CreateAlertFormPage'));

// Every triggers page renders SDUI content (usePages / <BlueprintRenderer>) — either
// directly (FleetPolicyPage, TriggerEventsPage, CreateAlertFormPage) or transitively
// through the shared EventSelectorDialog (TriggersPage, TriggerPage). Marking the whole
// group `needsBlueprint: true` makes PrivateRoute lazy-mount the BlueprintProvider only
// when the user actually visits `/alerts/*` — no cost on all other routes.
const routes = [
  {
    path: Location.ALERTS,
    component: FleetPolicyPage,
    needsBlueprint: true,
    exact: true,
  },
  {
    path: Location.ALERTS_TYPE,
    component: TriggerEventsPage,
    needsBlueprint: true,
    exact: true,
  },
  {
    path: Location.ALERTS_TRIGGERS,
    component: TriggersPage,
    needsBlueprint: true,
    exact: true,
  },
  {
    path: Location.ALERTS_TRIGGERS_CREATE,
    component: TriggerPage,
    needsBlueprint: true,
    exact: true,
  },
  {
    path: Location.ALERTS_TRIGGERS_EDIT,
    component: TriggerPage,
    needsBlueprint: true,
    exact: true,
  },
  {
    path: Location.ALERTS_LP,
    component: TriggersLandingPage,
    needsBlueprint: true,
    exact: true,
  },
  {
    path: Location.ALERTS_BLUEPRINT_CREATE,
    component: CreateAlertFormPage,
    needsBlueprint: true,
    exact: true,
  },
  {
    path: Location.ALERTS_BLUEPRINT_EDIT,
    component: CreateAlertFormPage,
    needsBlueprint: true,
    exact: true,
  },
];

export default routes;
